<pr-status-label
  [dense]="dense()"
  [color]="statusColor()"
  [label]="status() | map: statusLabel"
/>
